export default "__VITE_ASSET__DQZafflz__"